import instance from "../utils/network";
const GAME_API_SERVER_ENDPOINT = process.env.REACT_APP_REST_API_HOST + "/api";
const mock = "/club/club";

export interface GameClubDto {
  clubId: number;
  name: string;
  description: string;
  memberCount: number;
  imageUrl: string;
  isRequested: boolean;
  isJoined: boolean;
  totalHandCount: number;
  totalRingWinAmount: number;
  totalRingWinCount: number;
  totalTournamentJoinCount: number;
  totalTournamentWinCount: number;
  totalRakeAmount: number;
  totalBetAmount: number;
  topTotalHandCount: number;
  topTotalRingWinCount: number;
  topTotalTournamentJoinCount: number;
  topTotalTournamentWinCount: number;
  topTotalRakeAmount: number;
  topTotalBetAmount: number;
  clubRank: number;
  isOwner: boolean;
  requestId?: number;
  profileType: number;
  ownerNickname: string;
  createdAt: string;
}

export interface GameClubIsRequestStateResponse {
  club: GameClubDto;
  requestId: number;
}

export interface GameClubResponse {
  payload: {
    clubs: GameClubDto[];
    total: number;
  };
}

export interface GameClubDetailResponse {
  clubId: number;
  name: string;
  description: string;
  memberCount: number;
  isPublic: boolean;
  ownerUserId: number;
  imageUrl: string;
  totalHandCount: number;
  totalGPAmount: number;
  totalWinAmount: number;
  totalTournamentAmount: number;
  totalTournamentWinAmount: number;
  totalRakeAmount: number;
  profileType: number;
}

export interface GameClubMemberResponse {
  id: number;
  nickname: string;
  role: string;
  profileImage: string | null;
  handCount: number;
  winAmount: number;
  winCount: number;
  tournamentJoinCount: number;
  betAmount: number;
  isPlaying: boolean;
  lastAccessAt: string;
  joinedAt: string;
}

export interface GameClubChatResponse {
  id: number;
  nickname: string;
  userId: number;
  profile: null | string;
  message: string;
  time: string;
}

export interface GameClubRequestDto {
  id: number;
  status: string;
  userId: number;
  nickname: string;
  profileImage: string;
  requestId: number;
}
export interface GameClubRequestResponse {
  total: number;
  page: number;
  limit: number;
  requests: GameClubRequestDto[];
}

export interface GameCreateClubRequest {
  profile: string | null;
  clubName: string;
  clubInfo: string;
}

export interface GameMyRequestResponse {
  id: number;
  clubId: number;
  clubName: string;
}

export function createClub(
  data: FormData
): Promise<{ code: number; message: string }> {
  return instance.post(`${GAME_API_SERVER_ENDPOINT}/club`, data);
}

export function editClub(
  data: FormData,
  id: number
): Promise<{ code: number; message: string }> {
  return instance.post(`${GAME_API_SERVER_ENDPOINT}/club/edit/${id}`, data);
}

export function getClubList(
  page: number,
  limit: number,
  search: string,
  token: string
): Promise<GameClubResponse> {
  return instance.get(
    `${GAME_API_SERVER_ENDPOINT}/club?page=${page}&limit=${limit}&search=${search}&token=${token}`
  );
}

export function getClubDetail(
  id: number,
  token: string
): Promise<{ payload: GameClubDetailResponse; result: number }> {
  return instance.get(
    `${GAME_API_SERVER_ENDPOINT}/club/detail/${id}?token=${token}`
  );
}

export function getClubUserState(
  token: string,
  startDate?: string | null,
  endDate?: string | null
): Promise<{
  payload: GameClubDto | GameClubIsRequestStateResponse;
  result: number;
}> {
  const params = new URLSearchParams({ token });

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  return instance.get(
    `${GAME_API_SERVER_ENDPOINT}/club/my?${params.toString()}`
  );
}

export function getClubMember(
  id: number,
  token: string,
  startDate?: string | null,
  endDate?: string | null
): Promise<{ payload: { members: GameClubMemberResponse[] } }> {
  const params = new URLSearchParams({
    token,
    page: "1",
    limit: "999",
  });

  if (startDate) {
    params.append("startDate", startDate);
  }

  if (endDate) {
    params.append("endDate", endDate);
  }

  return instance.get(
    `${GAME_API_SERVER_ENDPOINT}/club/detail/${id}/members?${params.toString()}`
  );
}

export function getClubChat(id: number): Promise<GameClubChatResponse[]> {
  return instance.get(`${mock}/chat?id=${id}`);
}

export function joinClub(request: {
  clubId: number;
  token: string;
}): Promise<{ code: number; message: string }> {
  return instance.post(`${GAME_API_SERVER_ENDPOINT}/club/join`, request);
}

export function cancelJoinRequest(
  id: number,
  token: string
): Promise<{ code: number; message: string }> {
  return instance.delete(
    `${GAME_API_SERVER_ENDPOINT}/club/join/${id}?token=${token}`
  );
}

export function acceptJoinRequest(
  requestId: number,
  request: { token: string; approved: boolean }
): Promise<{ code: number; message: string }> {
  return instance.post(
    `${GAME_API_SERVER_ENDPOINT}/club/join/${requestId}`,
    request
  );
}
